// Helper function to get icon component by id
import { FOOD_TYPE_ICONS } from "../types/merchant";
import RestaurantIcon from "@mui/icons-material/Restaurant";

export const getIconComponent = (iconId) => {
  const iconConfig = FOOD_TYPE_ICONS.find((icon) => icon.id === iconId);
  return iconConfig ? iconConfig.icon : RestaurantIcon;
};

// Helper function to get icon color by id
export const getIconColor = (iconId) => {
  const iconConfig = FOOD_TYPE_ICONS.find((icon) => icon.id === iconId);
  return iconConfig ? iconConfig.color : "#1976d2";
};

export const getChannelLogoPath = (channelCode) => {
  const logoMap = {
    IFOOD: "logo-ifood.png",
    DELIVERY_DIRETO: "logo-ddireto.png",
    NEEMO: "logo-neemo.jpg",
    FOOD99: "logo-99.png",
    SLAPIE_POS: "logo.png",
  };

  return logoMap[channelCode] ? `/images/${logoMap[channelCode]}` : null;
};
